// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__z-4DY","content":"Dashboard_content__iIKBk"};